// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chase.css */

.chase-container {
    padding: 20px;
    font-family: Arial, sans-serif;
    color: #333;
    background-color: #f3f6f9;
    height: 100vh;
    overflow: hidden; /* Prevents scrolling on the main container */
  }
  
  .header {
    display: flex;
    align-items: center;
    padding-bottom: 15px;
  }
  
  .back-button {
    background: none;
    border: none;
    font-size: 1.15em;
    color: #0070ba;
    cursor: pointer;
  }
  
  .account-screen h2 {
    font-size: 1.3em;
    margin-left: 10px;
    color: #333;
  }
  
  .balance-info h1 {
    font-size: 2.5em;
    color: #333;
    margin: 15px 0;
  }
  
  .balance-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .balance-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .balance-label {
    font-size: 1em;
    color: #666;
  }
  
  .balance-amount {
    font-size: 1em;
    color: #0070ba;
  }
  
  .show-details {
    background: none;
    border: none;
    color: #0070ba;
    font-size: 1em;
    cursor: pointer;
    margin-top: 10px;
  }
  
  .account-actions {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
  }
  
  .account-actions button {
    background-color: #0070ba;
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 1em;
    cursor: pointer;
    margin: 5px;
  }
  
  .manage-account {
    margin-top: 20px;
    font-size: 1em;
    color: #333;
    padding: 10px;
    border-top: 1px solid #ddd;
  }
  
  .transactions-screen {
    width: 100%;
    height: calc(100vh - 80px); /* Adjusts height to allow scrolling */
    overflow-y: auto; /* Enables vertical scrolling */
    padding-right: 10px; /* Adds space for scrollbar */
  }
  
  .transaction-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .transaction-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #ddd;
  }
  
  .transaction-description {
    font-size: 0.9em;
    color: #333;
  }
  
  .transaction-location {
    font-size: 0.8em;
    color: #666;
  }
  
  .transaction-amount {
    font-size: 1em;
    color: red;
    text-align: right;
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/css/Chase.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,gBAAgB,EAAE,6CAA6C;EACjE;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,0BAA0B,EAAE,sCAAsC;IAClE,gBAAgB,EAAE,+BAA+B;IACjD,mBAAmB,EAAE,6BAA6B;EACpD;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,UAAU;IACV,iBAAiB;EACnB","sourcesContent":["/* Chase.css */\n\n.chase-container {\n    padding: 20px;\n    font-family: Arial, sans-serif;\n    color: #333;\n    background-color: #f3f6f9;\n    height: 100vh;\n    overflow: hidden; /* Prevents scrolling on the main container */\n  }\n  \n  .header {\n    display: flex;\n    align-items: center;\n    padding-bottom: 15px;\n  }\n  \n  .back-button {\n    background: none;\n    border: none;\n    font-size: 1.15em;\n    color: #0070ba;\n    cursor: pointer;\n  }\n  \n  .account-screen h2 {\n    font-size: 1.3em;\n    margin-left: 10px;\n    color: #333;\n  }\n  \n  .balance-info h1 {\n    font-size: 2.5em;\n    color: #333;\n    margin: 15px 0;\n  }\n  \n  .balance-details {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .balance-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .balance-label {\n    font-size: 1em;\n    color: #666;\n  }\n  \n  .balance-amount {\n    font-size: 1em;\n    color: #0070ba;\n  }\n  \n  .show-details {\n    background: none;\n    border: none;\n    color: #0070ba;\n    font-size: 1em;\n    cursor: pointer;\n    margin-top: 10px;\n  }\n  \n  .account-actions {\n    display: flex;\n    justify-content: space-around;\n    margin-top: 20px;\n  }\n  \n  .account-actions button {\n    background-color: #0070ba;\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 20px;\n    font-size: 1em;\n    cursor: pointer;\n    margin: 5px;\n  }\n  \n  .manage-account {\n    margin-top: 20px;\n    font-size: 1em;\n    color: #333;\n    padding: 10px;\n    border-top: 1px solid #ddd;\n  }\n  \n  .transactions-screen {\n    width: 100%;\n    height: calc(100vh - 80px); /* Adjusts height to allow scrolling */\n    overflow-y: auto; /* Enables vertical scrolling */\n    padding-right: 10px; /* Adds space for scrollbar */\n  }\n  \n  .transaction-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .transaction-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 0;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  .transaction-description {\n    font-size: 0.9em;\n    color: #333;\n  }\n  \n  .transaction-location {\n    font-size: 0.8em;\n    color: #666;\n  }\n  \n  .transaction-amount {\n    font-size: 1em;\n    color: red;\n    text-align: right;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
